export const urlDeeplinkRegex = () => new RegExp('([a-zA-Z0-9]+://)');
